module.exports = __webpack_public_path__ + "img/logo-icoev-actual-oscuro.f0a4415f.png";